import { call, put } from 'redux-saga/effects'

export function* getObjectSaga(action) {
    const { id, token, endpoint, setAction, errorAction } = action.payload
    try {
        const response = yield call(endpoint, { id, token: token })
        yield put({ type: setAction.type, payload: response })

    } catch (e) {
        console.log(e)
        yield put({ type: errorAction.type, payload: { getObjectError: e } })
    }
}

export function* updateObjectSaga(action) {
    const { id, values, token, endpoint, setAction, errorAction } = action.payload
    try {
        const response = yield call(endpoint, { id, token: token }, values)
        yield put({ type: setAction.type, payload: { ...response, ...{ objectUpdated: true } } })

    } catch (e) {
        console.log(e)
        yield put({ type: errorAction.type, payload: { updateObjectError: e } })
    }
}

export function* deleteObjectSaga(action) {
    const { setAction, errorAction } = action.payload
    try {
        // const response = yield call(endpoint, { id, auth: token })
        yield put({ type: setAction.type, payload: { ...{ objectDeleted: true } } })

    } catch (e) {
        console.log(e)
        yield put({ type: errorAction.type, payload: { deleteObjectError: e } })
    }
}

export function* addObjectSaga(action) {
    const { data, token, endpoint, setAction, errorAction } = action.payload
    try {
        const response = yield call(endpoint, { data, auth: token })
        yield put({ type: setAction.type, payload: { ...response.data, ...{ objectAdded: true } } })

    } catch (e) {
        console.log(e)
        yield put({ type: errorAction.type, payload: { addObjectError: e } })
    }
}
